import React from 'react';
import PropTypes from 'prop-types';
import { StyledModalBody } from './style';

const ModalBody = ({ className, children }) => (
  <StyledModalBody className={className}>{children}</StyledModalBody>
);

ModalBody.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string
};

export default ModalBody;
